import { Card, CardBody, Col } from "reactstrap";
import SweetAlert from "sweetalert2";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { Btn } from "../../../../AbstractElements";
import { PikachuAlerts, Pikachu } from "../../../../Constant";
import { PIKACHU_ALERT } from "../../../../Data/Bonus Ui/SweetAlert";

const PikachuAlert = () => {
  const displayAlert = () => {
    SweetAlert.fire({ text: "A wild Pikachu appeared! What do you want to do?", showCancelButton: true, cancelButtonText: "Run away!", confirmButtonText: "Throw Pokeball!", confirmButtonColor: "#33BFBF", denyButtonText: "Defeat", denyButtonColor: "#33BFBF", showDenyButton: true }).then((result) => {
      if (result.isConfirmed) {
        SweetAlert.fire({ icon: "success", title: "Yeah!", text: "Pikachu was caught!",confirmButtonColor: "#33BFBF" });
      } else if (result.dismiss) {
        SweetAlert.fire({ text: "Got away safely!",confirmButtonColor: "#33BFBF" });
      } else if (result.isDenied) {
        SweetAlert.fire({ text: "Pikachu fainted! You gained 500 XP!",confirmButtonColor: "#33BFBF" });
      }
    });
  };
  return (
    <Col xxl="3" lg="4" sm="6">
      <Card className="height-equal">
        <CommonCardHeader title={PikachuAlerts} span={PIKACHU_ALERT} />
        <CardBody className="btn-showcase">
          <Btn color="warning" className="sweet-1" type="button" onClick={displayAlert}>
            {Pikachu}
          </Btn>
        </CardBody>
      </Card>
    </Col>
  );
};

export default PikachuAlert;
